/* eslint-disable */
import React from "react";
import RenderAdminPage from "../RenderAdminPage";
import AuditTrailPanel from "../../Components/AuditTrailPanel";

function AuditTrail() {
  return (
    <RenderAdminPage title="Audit Trail">
      <AuditTrailPanel accent="indigo" />
    </RenderAdminPage>
  );
}

export default AuditTrail;
